import { createApi } from '@reduxjs/toolkit/query/react';
import { newBackendAxiosBaseQuery } from '../../utils/axiosBaseQuery';
import { PriceAdjustment } from './priceAdjustmentApiTypes';
import { serializeQueryArgsWithTenant } from '../tenantCacheKey';

// Manual price adjustments made while editing reservations. The list endpoint
// lives on the new (ECS) backend at GET /admin/price-adjustments; see
// new-backend/admin/src/controllers/priceAdjustmentController.ts.
export const priceAdjustmentApiSlice = createApi({
    reducerPath: 'priceAdjustmentApiSlice',
    serializeQueryArgs: serializeQueryArgsWithTenant,
    baseQuery: newBackendAxiosBaseQuery(),
    tagTypes: ['PriceAdjustmentList'],
    endpoints: (builder) => ({
        getPriceAdjustments: builder.query<PriceAdjustment[], void>({
            query: () => ({
                url: '/price-adjustments',
                method: 'GET',
            }),
            providesTags: ['PriceAdjustmentList'],
        }),
    }),
});

export const { useGetPriceAdjustmentsQuery } = priceAdjustmentApiSlice;
